import { Button, ConfigProvider, Flex, Typography } from "antd";
import { useTranslate } from "hooks/useTranslate/";
import { SHAPE_TYPES, ShapeType } from "../../../../types";
import { useAntTheme } from "hooks/useAntTheme";
import { radius } from "@libertify/ui";

export const ShapeButton = ({
  onClick,
  shapeType,
}: {
  onClick: (shapeType: ShapeType) => void;
  shapeType: ShapeType;
}) => {
  const t = useTranslate();
  const { theme } = useAntTheme();

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultBg: "#EEEEEE",
            defaultHoverBg: theme.colorTextDisabled,
            defaultBorderColor: "transparent",
            defaultHoverBorderColor: "transparent",
            defaultActiveBorderColor: "transparent",
          },
        },
      }}
    >
      <Flex vertical gap={8} justify="center">
        <Button
          onClick={() => onClick(shapeType)}
          style={{ width: 57, height: 47 }}
        >
          {getShapeIcon(shapeType)}
        </Button>
        <Typography.Text style={{ fontSize: 10, textAlign: "center" }}>
          {t(`components.templates.settings.shapesTab.shapes.${shapeType}`)}
        </Typography.Text>
      </Flex>
    </ConfigProvider>
  );
};

const getShapeIcon = (shapeType: ShapeType) => {
  const commonStyle = {
    width: 16,
    height: 16,
    border: "1px solid #000",
  };

  switch (shapeType) {
    case SHAPE_TYPES.RECTANGLE:
      return <div style={{ ...commonStyle }} />;
    case SHAPE_TYPES.CIRCLE:
      return (
        <div
          style={{
            ...commonStyle,
            borderRadius: radius.circle,
          }}
        />
      );
    case SHAPE_TYPES.LINE:
      return <div style={{ width: 15, height: 1, backgroundColor: "#000" }} />;
  }
};
